<template>
  <div class="w-full">
    <slot />
    <div
      class="fixed top-0 left-0 z-50 flex items-center justify-center w-full h-screen bg-realBlack"
    >
      <img
        src="@/assets/images/whiteLogo.png"
        class="md:w-auto w-[130px]"
        alt="Logo"
      />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>